<template>
  <div class="tla-loader-card">
    <LoaderComponent />
    <div class="tla-loader-card__text">{{ text }}</div>
  </div>
</template>

<script lang="ts">
import {
  Component, Vue, Prop
} from 'vue-property-decorator';

import LoaderComponent from '@/components/ui/LoaderComponent.vue';

@Component({
  components: {
  LoaderComponent
  }
  })
export default class LoaderCardComponent extends Vue {
  @Prop({ default: '' })
  public text!: string;
}
</script>
